module.exports = __webpack_public_path__ + "static/media/stop-record-btn.91ea6f65.png";